import { useQuery } from '@tanstack/react-query';
import {
  HistoryFilters,
  ITransactionHistoryItem,
  ITransactionHistoryItemResponse,
  TransactionHistoryParams
} from 'src/modules/history/types';
import { useRootStore } from 'src/store/root';
import { POLLING_INTERVAL, QueryKeys } from 'src/ui-config/queries';
import { useProtocolDataContext } from './useProtocolDataContext';
import { usePoolReservesHumanized } from './pool/usePoolReserves';

const INITIAL_DATA: ITransactionHistoryItem[] = [];

export const applyTxHistoryFilters = ({
  // searchQuery,
  filterQuery,
  txns,
}: HistoryFilters & { txns: ITransactionHistoryItem[] }) => {
  let filteredTxns: ITransactionHistoryItem[] = txns;

  // Apply search filter
  // if (searchQuery && searchQuery.length > 0) {
  //   const lowerSearchQuery = searchQuery.toLowerCase();
  //
  //   filteredTxns = txns.filter((txn: ITransactionHistoryItem) => {
  //     let collateralSymbol = '';
  //     let principalSymbol = '';
  //     let collateralName = '';
  //     let principalName = '';
  //     let symbol = '';
  //     let name = '';
  //
  //     if (hasCollateralReserve(txn)) {
  //       collateralSymbol = txn.collateralReserve.symbol.toLowerCase();
  //       collateralName = txn.collateralReserve.name.toLowerCase();
  //     }
  //
  //     if (hasPrincipalReserve(txn)) {
  //       principalSymbol = txn.principalReserve.symbol.toLowerCase();
  //       principalName = txn.principalReserve.name.toLowerCase();
  //     }
  //
  //     if (hasReserve(txn)) {
  //       symbol = txn.reserve.symbol.toLowerCase();
  //       name = txn.reserve.name.toLowerCase();
  //     }
  //
  //     // handle special case where user searches for ethereum but asset names are abbreviated as ether
  //     const altName = name.includes('ether') && !name.includes('tether') ? 'ethereum' : '';
  //
  //     return (
  //       symbol.includes(lowerSearchQuery) ||
  //       collateralSymbol.includes(lowerSearchQuery) ||
  //       principalSymbol.includes(lowerSearchQuery) ||
  //       name.includes(lowerSearchQuery) ||
  //       altName.includes(lowerSearchQuery) ||
  //       collateralName.includes(lowerSearchQuery) ||
  //       principalName.includes(lowerSearchQuery)
  //     );
  //   });
  // } else {
  //   filteredTxns = txns;
  // }

  // apply txn type filter
  if (filterQuery.length > 0) {
    filteredTxns = filteredTxns.filter((txn: ITransactionHistoryItem) => {
      return filterQuery.includes(txn.operationType);
    });
  }
  return filteredTxns;
};

export const useTransactionHistory = () => {
  const [currentMarketData, account] = useRootStore((state) => [
    state.currentMarketData,
    state.account,
  ]);

  const reserves = usePoolReservesHumanized(currentMarketData).data;

  const { currentNetworkConfig, currentChainId } = useProtocolDataContext();

  const fetchTransactionHistory = async ({ account, endpointURL }: TransactionHistoryParams) => {
    try {
      const url = `${endpointURL}/operations/${account}?chain_id=${currentChainId}`;
      const result = await fetch(url);
      const data: ITransactionHistoryItemResponse[] = await result.json();
      return data;
    } catch (error) {
      console.error('Error fetching transaction history:', error);
      return [] as ITransactionHistoryItemResponse[];
    }
  };

  const { data, ...rest } = useQuery({
    queryFn: () => fetchTransactionHistory({ endpointURL: currentNetworkConfig.yldrYpiUrl, account }),
    queryKey: [QueryKeys.TRANSACTION_HISTORY, account, currentChainId],
    enabled: !!account && !!currentNetworkConfig.yldrYpiUrl && !!currentChainId,
    refetchInterval: POLLING_INTERVAL,
    select: (response) => {
      const result = response.map((item) => ({
        amount: item.amount || 0,
        amount0: item.amount_0 || 0,
        amount1: item.amount_1 || 0,
        chainId: item.chain_id,
        erc1155TokenAddress: item.erc1155_token_address,
        erc1155TokenId: item.erc1155_token_id,
        operationType: item.operation_type,
        timestamp: item.timestamp,
        tokenAddress: item.token_address,
        transactionHash: item.transaction_hash,
        userAddress: item.user_address,
        reserve: reserves!.reservesData.find((reserve) => reserve.underlyingAsset === item.token_address?.toLowerCase())!,
      }));
      return result;
    },
  });

  return {
    data: data || INITIAL_DATA,
    ...rest,
  };
};
